"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgReviews(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M20 31L9.42 36.562l2.02-11.78-8.559-8.344 11.829-1.72L20 4l5.29 10.719 11.829 1.719-8.56 8.343 2.021 11.781L20 31z", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" }, void 0) }), void 0));
}
exports.default = SvgReviews;
//# sourceMappingURL=Reviews.js.map